export default { sha: 'f2176e92b70c6c2b324c8e4e9ef61431b4ec400f', buildNumber: 'undefined' }
